import React from "react";
import {
  formatFilterHzLabel,
  mergeFilterHzOptions,
} from "../utils/eegFilterFrequencyOptions";

type EegFilterFrequencySelectProps = {
  kind: "high-pass" | "low-pass";
  value: number;
  catalog: readonly number[];
  extraValues?: Array<number | null | undefined>;
  ariaLabel: string;
  title?: string;
  onChange: (nextHz: number) => void;
};

export default function EegFilterFrequencySelect({
  kind,
  value,
  catalog,
  extraValues = [],
  ariaLabel,
  title,
  onChange,
}: EegFilterFrequencySelectProps) {
  const options = mergeFilterHzOptions(catalog, [...extraValues, value]);
  const selected = options.includes(value) ? value : options[0] ?? value;

  return (
    <select
      className="eeg-toolbar-field-select"
      aria-label={ariaLabel}
      title={title}
      value={String(selected)}
      onChange={(event) => {
        const next = Number(event.target.value);
        if (Number.isFinite(next)) onChange(next);
      }}
    >
      {options.map((hz) => (
        <option key={`${kind}-${hz}`} value={hz}>
          {formatFilterHzLabel(kind, hz)}
        </option>
      ))}
    </select>
  );
}
